export enum UserRoleIds {
  ClientUser = '9fbd0e2b-5fe2-4d1f-a6bb-1dba307ecf04',
  ConsilioUser = '9fbd0e2b-5fe2-4d1f-a6bb-1dba307ecf03',
  ClientAdmin = '9fbd0e2b-5fe2-4d1f-a6bb-1dba307ecf02',
  SystemAdmin = '9fbd0e2b-5fe2-4d1f-a6bb-1dba307ecf01',
}

/**
 * Create new interface to fix lint issues in API
 */
export interface CreateUserRequest {
  consilioUserId: string;
  lastName: string;
  firstName: string;
  email: string;
  status: string;
  isLocked: boolean;
  isBillable: boolean;
  roleId: string | undefined;
  projectId: string;
}

export interface UpdateUserRequest {
  userId?: string;
  lastName: string;
  firstName: string;
  status: string;
  isLocked?: boolean;
  isBillable: boolean;
  ipAddressList: string[];
}

export interface UpdateUserStatusRequest {
  status: string;
  userIds: string[];
}

export interface BulkUploadEditUserRequest {
  userInfo: {
    userImportTempId: string | undefined;
    firstName: string;
    lastName: string;
    emailAddress: string;
    isBillable: boolean;
    ipAddressList: string[] | undefined;
  };
  clientInfo: {
    roleId: string;
    permissionGroupIds?: (string | undefined)[];
    projectPermissionGroupIds?: (string | undefined)[];
    clientPermissionGroupIds?: (string | undefined)[];
    projects: {
      projectId?: string;
      workspaceIds: (string | undefined)[];
    }[];
  };
}

export interface UploadedAttachmentDoc {
  feedbackAttachmentId: number;
  filePath: string;
  fileSize: number;
  contentType: string;
}

export interface UserFeedbackPayload {
  title: string;
  description: string;
  attachments: UploadedAttachmentDoc[];
  severity: number;
  userName: string;
  email: string;
}
